module.exports = __webpack_public_path__ + "media/images/pen_yellow-d9a369f6.png";